// imports
import React, { useState } from 'react';
import { IActionItem } from '../../../common/types';
import Dropdown from '../../../atoms/dropdown/list';

// interfaces / types / consts
interface Props {
  tabs: IActionItem[];
  defaultSelected?: string;
  notificationBadge?: number;
}

// exports
export default function Topbar(props: Props): JSX.Element {
  const { tabs, defaultSelected, notificationBadge } = props;
  const [activeTab, setActiveTab] = useState(defaultSelected || tabs[0].key);
  return (
    <div className="topbar-container">
      <div className="mobile">
        <Dropdown className="topbar-dropdown" items={tabs} />
      </div>
      <div className="desktop">
        {tabs.map((subTab, idx) => (
          <button
            type="button"
            key={subTab.key}
            onClick={() => {
              setActiveTab(subTab.key);
              if (subTab.onClick) { subTab.onClick(); }
            }}
            className={activeTab === subTab.key ? 'sub-tab active-sub-tab' : 'sub-tab'}
          >
            {subTab.display || subTab.key}
            {(idx === tabs.length - 1 && notificationBadge) ? <span className="notification-badge">{notificationBadge}</span> : ''}
          </button>
        ))}
      </div>
    </div>
  );
}

// default props
Topbar.defaultProps = { defaultSelected: '', notificationBadge: 0 };
